/**
 * utils/safeUtil.ts
 * --------------------------------------------------
 * 提供查询字符串解析与 UID 本地缓存功能。
 */

export class SafeUtil {
  /**
   * 读取当前 URL 的查询参数并返回指定 key 的值。
   * 在服务器端渲染期间（没有 window 对象时）返回空字符串。
   */
  static getParam(key: string): string {
    if (typeof window === 'undefined') return '';
    return new URLSearchParams(window.location.search).get(key) ?? '';
  }

  /**
   * 将 q1id / w1id 参数写入 localStorage，用于后续安全校验。
   * 调用时机：仅在浏览器环境（客户端）执行。
   */
  static cacheSafeUid(): void {
    if (typeof window === 'undefined') return;

    const q1id = this.getParam('q1id');
    const w1id = this.getParam('w1id');

    // 始终以字符串形式保存，保持和原实现一致
    window.localStorage.setItem('q1id', q1id);
    window.localStorage.setItem('w1id', w1id);
  }
}
